import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import { Provider } from "react-redux";
import { store } from './store/store';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { BrowserRouter } from 'react-router-dom';

const root = ReactDOM.createRoot(document.getElementById('root'));
const queryClient = new QueryClient();

// async function enableMocking() {
//   const { worker } = await import('./mocks/node')
//   // console.log(worker);
//   return worker.start({
//     serviceWorker: {
//       url: '/mockServiceWorker.js',
//     },
//   })
// }

root.render(
  <Provider store={store}>
      <QueryClientProvider client={queryClient}>
        <BrowserRouter basename="/">
          <App />
        </BrowserRouter>
      </QueryClientProvider>
  </Provider>
);
// enableMocking().then(() =>  {
// })
